import {
  AlertApi,
  AgencyApi,
  AgencyGroupApi,
  BimDataApi,
  BlueGenChatbotApi,
  ClearanceApi,
  ClearanceRecoveryApi,
  CustomViewApi,
  CurrentProjectRoleApi,
  Configuration,
  ContributorRecoveryApi,
  DocumentAnalysisApi,
  DocumentPhaseApi,
  DocumentTypeApi,
  DictateApi,
  DestinationApi,
  DocumentPredictionApi,
  ElectricalContinuityMeasurementApi,
  ExternalSocietyApi,
  FavoriteApi,
  FileTransferApi,
  FireDetectionApi,
  KpiApi,
  LightningApi,
  LightningMeasurementApi,
  LightningMeasurementResultApi,
  JustificationApi,
  LowVoltageApi,
  MessageApi,
  MissionApi,
  NewsApi,
  PcAtRecoveryApi,
  PlanAnalysisApi,
  ProjectApi,
  ProjectDocumentApi,
  ProjectDuplicationApi,
  ProjectMeasurementApi,
  ProjectResultApi,
  ProjectRoleApi,
  ProjectStatsApi,
  PvAnalysisApi,
  RD0WorksApi,
  ReferentielUpdateApi,
  ReportApi,
  ResultEvaluationApi,
  ResultTypeApi,
  ResultVerificationApi,
  RoomClearanceApi,
  RiskApi,
  RiskyLocalsApi,
  SafetyReviewApi,
  SafetyReviewRecoveryApi,
  SediDocumentApi,
  StaffingApi,
  StaffingRecoveryApi,
  TaskApi,
  TechnicalSupportApi,
  TopicActionPlanApi,
  SectionTopicApi,
  TopicAgentCallApi,
  TopicAnalysisApi,
  TopicApi,
  TopicCommentApi,
  TypeApi,
  UserMeasurementApi,
  UserProfileApi,
  VisualExaminationApi,
  VisualExaminationResultApi,
  WorkDescriptionApi,
  WorkspaceApi,
} from "@socotec.io/rapsotec-back-sdk";
import { useOidcStore } from "vue3-oidc";
import { useLanguageStore } from "@/store/language.js";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_RAPSOTEC_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
  middleware: [
    {
      pre(context) {
        context.init.headers = {
          ...context.init.headers,
          "Accept-Language": useLanguageStore().lang,
        };
        return { url: context.url, init: context.init };
      },
    },
  ],
});

export const useFavoriteApi = () => new FavoriteApi(configuration);
export const useFireDetectionApi = () => new FireDetectionApi(configuration);
export const useLowVoltageApi = () => new LowVoltageApi(configuration);
export const useRiskApi = () => new RiskApi(configuration);
export const useRiskyLocalsApi = () => new RiskyLocalsApi(configuration);
export const useLightningApi = () => new LightningApi(configuration);
export const useVisualExaminationApi = () => new VisualExaminationApi(configuration);
export const useVisualExaminationResultApi = () => new VisualExaminationResultApi(configuration);
export const useLightningMeasurementApi = () => new LightningMeasurementApi(configuration);
export const useLightningMeasurementResultApi = () =>
  new LightningMeasurementResultApi(configuration);
export const useElectricalContinuityMeasurementApi = () =>
  new ElectricalContinuityMeasurementApi(configuration);
export const useResultTypeApi = () => new ResultTypeApi(configuration);
export const useResultEvaluationApi = () => new ResultEvaluationApi(configuration);
export const useResultVerificationApi = () => new ResultVerificationApi(configuration);
export const useProjectResultApi = () => new ProjectResultApi(configuration);
export const useReportApi = () => new ReportApi(configuration);
export const useProjectApi = () => new ProjectApi(configuration);
export const useProjectRoleApi = () => new ProjectRoleApi(configuration);
export const useCurrentProjectRoleApi = () => new CurrentProjectRoleApi(configuration);
export const useProjectDuplicationApi = () => new ProjectDuplicationApi(configuration);
export const useBimDataApi = () => new BimDataApi(configuration);
export const useProjectDocumentApi = () => new ProjectDocumentApi(configuration);
export const useProjectStatsApi = () => new ProjectStatsApi(configuration);
export const useKpiApi = () => new KpiApi(configuration);
export const useRD0WorksApi = () => new RD0WorksApi(configuration);
export const useReferentielUpdateApi = () => new ReferentielUpdateApi(configuration);
export const useTopicActionPlanApi = () => new TopicActionPlanApi(configuration);
export const useTopicApi = () => new TopicApi(configuration);
export const useTopicAgentCallApi = () => new TopicAgentCallApi(configuration);
export const useTopicCommentApi = () => new TopicCommentApi(configuration);
export const useSectionTopicApi = () => new SectionTopicApi(configuration);
export const useUserProfileApi = () => new UserProfileApi(configuration);
export const useWorkspaceApi = () => new WorkspaceApi(configuration);
export const useAlertApi = () => new AlertApi(configuration);
export const useExternalSocietyApi = () => new ExternalSocietyApi(configuration);
export const useUserMeasurementApi = () => new UserMeasurementApi(configuration);
export const useSediDocumentApi = () => new SediDocumentApi(configuration);
export const useFileTransferApi = () => new FileTransferApi(configuration);
export const usePlanAnalysisApi = () => new PlanAnalysisApi(configuration);
export const useTopicAnalysisApi = () => new TopicAnalysisApi(configuration);
export const useDocumentAnalysisApi = () => new DocumentAnalysisApi(configuration);
export const useDocumentPredictionApi = () => new DocumentPredictionApi(configuration);
export const usePvAnalysisApi = () => new PvAnalysisApi(configuration);
export const useContributorRecoveryApi = () => new ContributorRecoveryApi(configuration);
export const usePcAtRecoveryApi = () => new PcAtRecoveryApi(configuration);
export const useSafetyReviewRecoveryApi = () => new SafetyReviewRecoveryApi(configuration);
export const useClearanceRecoveryApi = () => new ClearanceRecoveryApi(configuration);
export const useCustomViewApi = () => new CustomViewApi(configuration);
export const useDocumentTypeApi = () => new DocumentTypeApi(configuration);
export const useDocumentPhaseApi = () => new DocumentPhaseApi(configuration);
export const useMessageApi = () => new MessageApi(configuration);
export const useNewsApi = () => new NewsApi(configuration);
export const useTaskApi = () => new TaskApi(configuration);
export const useBlueGenChatbotApi = () => new BlueGenChatbotApi(configuration);
export const useStaffingRecoveryApi = () => new StaffingRecoveryApi(configuration);
export const useWorkDescriptionApi = () => new WorkDescriptionApi(configuration);
export const useStaffingApi = () => new StaffingApi(configuration);
export const useClearanceApi = () => new ClearanceApi(configuration);
export const useRoomClearanceApi = () => new RoomClearanceApi(configuration);
export const useJustificationApi = () => new JustificationApi(configuration);
export const useProjectMeasurementApi = () => new ProjectMeasurementApi(configuration);
export const useSafetyReviewApi = () => new SafetyReviewApi(configuration);
export const useDictateApi = () => new DictateApi(configuration);
export const useMissionApi = () => new MissionApi(configuration);
export const useDestinationApi = () => new DestinationApi(configuration);
export const useTypeApi = () => new TypeApi(configuration);
export const useAgencyApi = () => new AgencyApi(configuration);
export const useAgencyGroupApi = () => new AgencyGroupApi(configuration);
export const useTechnicalSupportApi = () => new TechnicalSupportApi(configuration);
